(function () {
    try {
        window.GustaffoChat || (function (window) {
                // Since Internet Explorer does not support this function...
                if (!String.prototype.startsWith) {
                    String.prototype.startsWith = function (searchString, position) {
                        position = position || 0;
                        return this.indexOf(searchString, position) === position;
                    };
                }

                window.GustaffoChat = function () {
                    var id;
                    var container;
                    var user = {};
                    var userChangedCb;
                    // Constants - Widget style settings
                    var SCRIPT_ID = 'gustaffo-chat-widget-loader', WIDGET_ID = 'gustaffo-chat-widget';
                    var WIDTH             = 300,
                        HEIGHT_HEADER     = 50,    // Size of header/banner
                        HEIGHT_MAX        = 500,   // Size of widget (if not mobile)
                        BOTTOM_MAXIMIZED  = 0,
                        OFFSET_DESKTOP    = 50,
                        OFFSET_MOBILE     = 10,
                        MOBILE_BREAKPOINT = 500;
                    var positionBottomCurrent,  // Current position bottom
                        positionBottomMin,  // Position bottom when minimized
                        heightMax,
                        isMinimized = true;
                    // Constants - GET Parameters for language
                    var JSON_FIX_LANG_PARAM_NAME = 'lang';
                    var JSON_GET_LANG_PARAM_NAME = 'langGet';
                    var JSON_PATH_LANG_PARAM_NAME = 'langPath';
                    var JSON_LANG_DEFAULT_NAME = 'langDefault';
                    var JSON_GET_BACKUP_DEFAULT_LANG = 'en';

                    var widget = {
                        init: init,
                        openWidget: openWidget,
                        setUserCallback: setUserCallback,
                        changeLang: changeLang,
                        login: login,
                        logout: logout,
                        reloadHistory: reloadHistory
                    };
                    return widget;

                    function init(json) {
                        console.log('Initializing widget loader...', json);
                        id = WIDGET_ID;

                        var doc = window.document, widget;
                        if (doc.getElementById(id)) {
                            console.warn(id + ' already exists.');
                            return;
                        }
                        json.id = id;

                        // Extracting url data
                        var pathArray = doc.getElementById(SCRIPT_ID)
                                           .src
                                           .split('/');
                        var urlBase = pathArray[ 0 ] + '//' + pathArray[ 2 ];
                        json.urlBase = encodeURIComponent(urlBase);

                        var url = '';
                        for (var i = 0; i < pathArray.length - 1; i++) {
                            url += pathArray[ i ] + '/';
                        }
                        url += 'chatWidget.html?';

                        // var urlBase = new URL(doc.getElementById(SCRIPT_ID).src);    // Not supported in IE
                        // var url = urlBase.origin + urlBase.pathname.substring(0, urlBase.pathname.lastIndexOf('/') + 1) + 'chatWidget.html?';
                        // var url = 'http://localhost:8888/widgets/chat/chatWidget.html?';

                        // Check if hardcoded language should be used or loaded dynamically over GET parameter or path
                        var defaultLang = getDefaultLang(json[ JSON_LANG_DEFAULT_NAME ]);
                        var lang;
                        if (json.hasOwnProperty(JSON_FIX_LANG_PARAM_NAME)) {
                            lang = json[ JSON_FIX_LANG_PARAM_NAME ];
                        } else if (json.hasOwnProperty(JSON_GET_LANG_PARAM_NAME)) {
                            lang = getLangFromUrl(json[ JSON_GET_LANG_PARAM_NAME ], defaultLang);
                        } else if (json.hasOwnProperty(JSON_PATH_LANG_PARAM_NAME)) {
                            lang = getLangFromPath(defaultLang);
                        } else {
                            lang = defaultLang;
                        }
                        json[ JSON_FIX_LANG_PARAM_NAME ] = lang;

                        Object.keys(json)
                              .forEach(function (key) {
                                  url += key + '=' + convertGetValues(json[ key ]) + '&';
                              });
                        url = url.substr(0, url.length - 1);

                        var isVisible = (json.isVisible !== undefined) ? json.isVisible : true;

                        // Create iframe with container
                        container = doc.createElement('div');
                        container.id = id;
                        container.style.position = 'fixed';
                        container.style.overflow = 'hidden';
                        container.style.zIndex = '999';
                        container.style.display = (isVisible) ? 'block' : 'none';
                        container.style.visibility = 'hidden';
                        doc.body.insertBefore(container, doc.body.firstChild);
                        widget = doc.createElement('iframe');
                        widget.setAttribute('title', id);
                        widget.setAttribute('name', id);
                        widget.setAttribute('src', url);
                        widget.setAttribute('frameborder', '0');
                        widget.setAttribute('scrolling', 'auto');
                        widget.setAttribute('width', '100%');
                        widget.setAttribute('height', '100%');
                        container.appendChild(widget);

                        // Check screen resolution
                        window.onresize = function () {
                            checkScreen();
                        };
                        checkScreen();
                        sendState();

                        // Set callbacks
                        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
                        var eventer = window[ eventMethod ];
                        var messageEvent = (eventMethod === 'attachEvent') ? 'onmessage' : 'message';

                        eventer(messageEvent, function (e) {
                            var key = e.message ? 'message' : 'data';
                            var data = e[ key ];

                            if (!data) {
                                console.warn('Could not extract data from message.');
                            } else if (data.substr(id.length).startsWith('.toggle')) {
                                toggleWidget();
                            } else if (data.substr(id.length).startsWith('.open')) {
                                openWidget();
                            } else if (data.substr(id.length).startsWith('.show')) {
                                showWidget(null);
                            } else if (data.substr(id.length).startsWith('.resize')) {
                                sendResize();
                            } else if (data.substr(id.length).startsWith('.userdata')) {
                                forwardUserData(data.substr(id.length + 10));
                            } else if (data.substr(id.length).startsWith('.usercancel')) {
                                forwardUserData(null);
                            }
                        }, false);
                    }

                    function convertGetValues(variable) {
                        if (typeof(variable) === typeof(true)) {
                            if (variable === true) {
                                return '1';
                            } else {
                                return '0';
                            }
                        } else {
                            return variable;
                        }
                    }

                    function getLangFromUrl(getParamName, defaultLang) {
                        if (window.location.href.split('?').length === 2) {
                            let gets = window.location.href.split('?')[ 1 ].split('&');
                            for (let i = 0; i < gets.length; i++) {
                                let temp = gets[ i ].split('=');
                                if (temp[ 0 ] === getParamName) {
                                    return temp[ 1 ];
                                }
                            }
                        }
                        return defaultLang;
                    }

                    function getLangFromPath(defaultLang) {
                        if (window.location.pathname.length > 3) {
                            return window.location.pathname.substr(1, 2);
                        }
                        return defaultLang;
                    }

                    function getLangFromBrowser() {
                        return navigator.language || navigator.userLanguage;
                    }

                    function getDefaultLang(defaultLang) {
                        var browserLang = getLangFromBrowser();
                        if (browserLang) {
                            return browserLang;
                        }
                        return (defaultLang) ? defaultLang : JSON_GET_BACKUP_DEFAULT_LANG;
                    }

                    function toggleWidget() {
                        isMinimized = !isMinimized;
                        positionBottomCurrent = (isMinimized) ? positionBottomMin : BOTTOM_MAXIMIZED;
                        container.style.bottom = positionBottomCurrent + 'px';
                        sendState();
                    }

                    function openWidget() {
                        isMinimized = false;
                        positionBottomCurrent = BOTTOM_MAXIMIZED;
                        container.style.bottom = positionBottomCurrent + 'px';
                        sendState();
                    }

                    function showWidget() {
                        container.style.visibility = 'visible';
                    }

                    function checkScreen() {
                        var width = document.documentElement.clientWidth;
                        var height = document.documentElement.clientHeight;

                        if (width < MOBILE_BREAKPOINT) {
                            setStyle(width - 2 * OFFSET_MOBILE, height - OFFSET_MOBILE, OFFSET_MOBILE);
                        } else {
                            if (height > HEIGHT_MAX) {
                                height = HEIGHT_MAX;
                            }
                            setStyle(WIDTH, height, OFFSET_DESKTOP);
                        }
                    }

                    function setStyle(width, height, offsetLeft) {
                        heightMax = height;

                        container.style.width = width + 'px';
                        container.style.height = height + 'px';
                        container.style.right = offsetLeft + 'px';

                        setPositionBottom(height);
                        container.style.bottom = positionBottomCurrent + 'px';

                        sendResize();
                    }

                    function setPositionBottom(height) {
                        positionBottomMin = HEIGHT_HEADER - height;

                        if (isMinimized) {
                            positionBottomCurrent = positionBottomMin;
                        } else {
                            positionBottomCurrent = 0;
                        }
                    }

                    function sendResize() {
                        window.frames[ id ].postMessage(id + '.resize.' + (heightMax - HEIGHT_HEADER) + '|' + HEIGHT_HEADER, '*');
                    }

                    function forwardUserData(userData) {
                        if (userChangedCb) {
                            user = (userData !== null) ? JSON.parse(userData) : null;
                            userChangedCb(user);
                        }
                    }

                    function setUserCallback(callback) {
                        if (callback) {
                            userChangedCb = callback;
                        }
                    }

                    function changeLang(lang) {
                        if (lang) {
                            window.frames[ id ].postMessage(id + '.lang.' + lang, '*');
                        }
                    }

                    function login() {
                        window.frames[ id ].postMessage(id + '.login', '*');
                    }

                    function logout() {
                        window.frames[ id ].postMessage(id + '.logout', '*');
                    }

                    function sendState() {
                        const state = isMinimized ? 1 : 0;
                        window.frames[ id ].postMessage(id + '.state.' + state, '*');
                    }

                    function reloadHistory() {
                        window.frames[ id ].postMessage(id + '.', '*');
                    }
                }();

                // Call when everything is setup
                if (window.gustaffoChatAsyncInit) {
                    window.gustaffoChatAsyncInit();
                } else {
                    console.warn('Async-init for chat-widget has not been defined.');
                }
            }
        )(window);
    }
    catch (e) {
        console.error(e);
    }
})();
